<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import lottie from 'lottie-web'
import { TweenMax as Tween, Power1 } from 'gsap'

export default {

  name: 'IntroSlide',

  props: {
    label: {
      type: String,
      required: true
    },
    head: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      animation: null
    }
  },

  computed: {
    windowWidth () {
      return this.$store.getters['window'].width
    },

    isMobile () {
      return this.windowWidth < 768
    }
  },

  watch: {
    'windowWidth': 'checkState'
  },

  mounted () {
    this.checkState()
  },

  methods: {
    checkState () {
      if (this.isMobile && this.animation) {
        this.animation.destroy()
        this.animation = null
      }

      if (!this.isMobile && this.animation === null) {
        this.initAnimation()
      }
    },

    initAnimation () {
      if (this.$refs.canvas) {
        this.animation = lottie.loadAnimation({
          container: this.$refs.canvas,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          //prop for prod build
          path: '/bundle/animations/intro-slide-0.json',
          //prop for dev develpoment
//          animationData: require('./../../../static/animations/intro-slide-0.json')
        })
      }
    },

    appear (el, done) {
      const els = el.querySelectorAll('[data-item]');

      Tween.staggerFrom(els, 1, {
        autoAlpha: 0,
        scale: 1.2,
        ease: Power1.easeInOut,
        onStart () {
          if (this.target) this.target.style.transformOrigin = 'left'
        },
        onComplete () {
          if (this.target) this.target.removeAttribute('style')
        }
      }, 0.1, done)
    },

    enter (el, done) {
      const els = el.querySelectorAll('[data-item]');

      if (this.$refs.media) {
        Tween.from(this.$refs.media, 0.5, {
          autoAlpha: 0,
          ease: Power1.easeOut
        })
      }

      Tween.staggerFrom(els, 0.5, {
        autoAlpha: 0,
        y: -this.$store.state.app.window.height / 3,
        ease: Power1.easeOut,
        onComplete () {
          if (this.target) this.target.removeAttribute('style')
        }
      }, 0, done)
    },

    leave (el, done) {
      const els = el.querySelectorAll('[data-item]')

      if (this.$refs.media) {
        Tween.to(this.$refs.media, 1, {
          autoAlpha: 0,
          ease: Power1.easeOut
        })
      }

      Tween.staggerTo(els, 1, {
        autoAlpha: 0,
        y: -this.$store.state.app.window.height / 3,
        ease: Power1.easeOut
      }, 0, done)
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

section.slide.intro.intro-wrap
  .intro-media(ref="media")
    img.intro-media__image(v-if="isMobile", src="/bundle/images/intro-slide-image.svg", alt="image")
    .intro-media__canvas(v-else ref="canvas")
  article.intro-content
    h1.intro-content__label(data-item) {{ label }}
    h2.intro-content__heading(v-html="head" data-item)

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

// .intro
//   background #0052A6 url('/public/images/intro-slide-image.png') center no-repeat

.intro-media
  z-index 1
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin auto
  opacity 0.3
  display flex
  justify-content center
  align-items center

  &__image
    max-width 320px
    width 70%

  &__canvas
    width: 100%
    height: 100%

.intro-wrap
  height: 100vh
  min-height: 500px
  background-color: #0052a6;
  overflow: hidden
  position: fixed
  top: 0
  left: 0
  +mobile()
    height: 80vh
    min-height: 300px

.intro-content
  z-index 2
  position relative
  display flex
  flex-direction column
  max-width 1074px
  width 100%
  padding 0 90px
  +hd()
    max-width 1390px
  +mobile()
    padding 0 30px

  &__label
    font-size 16px
    font-weight 500
    line-height 23px
    text-transform uppercase

    +hd()
      font-size 18px

    & + *
      margin-top 26px

  &__heading
    font-size 86px
    font-weight 500
    line-height 78px
    max-width 700px

    +hd()
      font-size 100px
      line-height 87px
    +tablet()
      font-size 76px
      font-weight normal

    +mobile()
      font-size 34px
      line-height 37px
      font-weight 500

  &__navigation
    position absolute
    top 0
    right 0
    bottom 0
    margin auto 0

</style>



// WEBPACK FOOTER //
// intro-slide.vue?4b4fe30e